import React, { useEffect , useState} from "react";
import TopSecDashboard from './dashboardComponents/TopSecDashboard';
import MidSecDashboard from './dashboardComponents/MidSecDashboar';
import HowItWorksSecDashboard from './dashboardComponents/HowItSecDashboard';
import HistorySecDashboard from './dashboardComponents/HistorySecDashboard';
import ReferNowSection from "./dashboardComponents/ReferNowSection";
import TopRefers from "./dashboardComponents/TopRefers.js";
import { useMixpanel } from '../context/MixpanelContext'; 
import mixpanel from "mixpanel-browser";
import { logDOM } from "@testing-library/react";
import {notifyVisitorEvent, fetchCampaignDetails} from "../api/action"
import RewardPopup from "../common/RewardPopup.js";

const Dashboard = () => {
  const { mixpanelUserId } = useMixpanel();
  const [showRewardPopup, setShowRewardPopup] = useState(() => {
    return localStorage.getItem("donotshowrewardpopup") !== "true";
  });
  const [campaignDetails, setCampaignDetails] = useState(null);

  useEffect(() => {
    fetchCampaignDetails()
      .then((data) => {
        console.log("Campaign Details:", data);
        setCampaignDetails(data);
      })
      .catch((error) => {
        console.error("Error fetching campaign details:", error);
      });
  }, []);

  useEffect(() => {
    const payload = {
      event_name: "Viewed_PERP_Dashboard",
      event_body: {},
    };
  
    notifyVisitorEvent(payload)
      .then((response) => {
        console.log("NotifyVisitor Event Sent:", response);
      })
      .catch((error) => {
        console.error("Error sending NotifyVisitor event:", error);
      });
  }, []);

  useEffect(() => { 
    if (mixpanelUserId) {
      mixpanel.identify(mixpanelUserId);

      mixpanel.track("Viewed_PERP_Dashboard", {}); 
      
    }
  }, [mixpanelUserId]);
  function getTokenFromURL() {
    const params = new URLSearchParams(window.location.search);
    return params.get("token"); 
  }
  const token = getTokenFromURL();
  if (token) {
    localStorage.setItem('authToken', token);
  }

  return (
    <>
      <div className='container'>
      {showRewardPopup && campaignDetails?.show_milestone_popup && (
  <RewardPopup
    coins={campaignDetails?.reward_coins }
    onClose={() => {
      
      if (mixpanelUserId) {
        mixpanel.identify(mixpanelUserId);
      }
      mixpanel.track("perp_milestone_popup", {
        "Properties": "dismissed",
      });
      localStorage.setItem("donotshowrewardpopup", "true");
      setShowRewardPopup(false);
    }}
  />
)}

        <div className="max-width-fix" id='background'>
          <TopSecDashboard />
          <div className='mainbackground'>
            <div style={{ marginLeft: "20px", marginRight: "20px" }}>
              <MidSecDashboard />
              {/* <HowItWorksSecDashboard /> */}
            </div>
            <HistorySecDashboard />
            <ReferNowSection />
            <TopRefers />
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
